import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { environment } from "../environment";
import { MachineStatus } from "../models/machines.model";
import { BulkAddDevicesTable } from "../shared/Tables/BulkAddDeviceTable";
import { DevicesTable } from "../shared/Tables/DevicesTable";
import { csvToJSON } from "../utils/csvToJSON.util";
import { DateUtil } from "../utils/date.util";
import { useAxios } from "./useAxios";
//import groupBy from 'lodash/groupBy';
//import values from "lodash/values";

//DEMO 1 - TEMPORAY HARDCODED
import adrianstucki from "../mock/Devices/adrian.stucki.json";
import alexandraklee from "../mock/Devices/alexandra.klee.json";
import jensheiringhoff from "../mock/Devices/jens.heiringhoff.json";
import michaelboostbar from "../mock/Devices/michael.boostbar.json";

import { useUserContext } from "../context/user.context";
import { DASHBOARD_ROUTES } from "../router/RoutesEnum";
import { toast } from "react-toastify";
import { EMPTY_DATA_DASH } from "../constants";

export const useDevices = () => {
  //DEMO 1 - TEMPORAY HARDCODED
  const DEMO1_EMAILS = [
    { email: "jens.heiringhoff@tchibo-coffeeservice.de", json: jensheiringhoff },
    { email: "alexandra@cafimat.ch", json: alexandraklee },
    { email: "adrian.stucki@nurissa.ch", json: adrianstucki },
    { email: "michael@boostbar.ch", json: michaelboostbar },
    //{ email: "simon.brunner@brister.ch", json: simonbrunner },

    // { email: "patricija.furdi@smarpay.eu", json: michaelboostbar } //TEST EMAIL - DONT FORGET TO COMMENT OUT!!!
  ];

  const { t } = useTranslation();

  //const format = "dd.MM.yyyy HH:mm:ss";

  const { initialized, keycloak } = useKeycloak();
  const kcToken = keycloak?.token || "";

  //const { email } = useKeycloakData()
  const { axiosInstance } = useAxios();

  const { merchantId } = useUserContext();

  const navigate = useNavigate();

  const [machinesData, setMachineData] = useState([]);
  const [filteredMachineData, setFilteredMachineData] = useState([]);

  const [totalNumberOfDevices, setTotalNumberOfDevices] = useState(0);
  const [totalWorking, setTotalWorking] = useState(0);
  const [totalWarning, setTotalWarning] = useState(0);
  const [totalError, setTotalError] = useState(0);
  const [totalUnknown, setTotalUnknown] = useState(0);
  const [machineAddStatus, setMachineAddStatus] = useState(0);

  //FILTERS FROM 01 CURENT MONTH till TODAY
  const [startDate, setStartDate] = useState(DateUtil.firstDayOfCurrentMonth);
  const [endDate, setEndDate] = useState(new Date());

  const [machineStatuses, setMachineStatuses] = useState(["Select Machine Status"]);
  const [machineNames, setMachineNames] = useState(["Select Machine name"]);
  const [machineCities, setMachineCities] = useState(["Select Machine City"]);
  const [machineGroup, setmachineGroup] = useState(["Select machine group"]);

  const [devicesTableData, setDevicesTableData] = useState([]);
  const [bulkTableData, setBulkTableData] = useState([]);
  const [allRows, setAllDevices] = useState(0);
  const [selectedRows, setSelectedDevicesLength] = useState(0);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [editableMachine, setEditableMachine] = useState([]);

  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finish, setFinish] = useState(false);
  const [finishEdit, setFinishEdit] = useState(false);
  const [postingFlag, setPostingFlag] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalForDelete, setOpenModalForDelete] = useState(false);
  const [isRequestGood, setIsRequestGood] = useState(null);
  const [machineId, setMachineId] = useState(null);

  const [addToTrackingPool, setAddToTrackingPool] = useState(false);

  const [areMachinesVisible, setAreMachinesVisible] = useState(true);

  //CREATION OF DEVICES
  const renderBulkTable = () => {
    return <BulkAddDevicesTable bulkTableData={bulkTableData} />;
  };

  const deviceConnectivityStatus = (status) => {
    if (status === 0) return t("devices.deviceConnectivityStatus.connectivityStatusOffline")
    else if (status === 1) return t("devices.deviceConnectivityStatus.connectivityStatusReachable")
    else if (status === 2) return t("devices.deviceConnectivityStatus.connectivityStatusOnline")
  }

  const addNewDeviceData = (csvData) => {
    const toJson = csvToJSON(csvData);
    setBulkTableData(toJson);
  };

  const getmachineGroup = (merchant) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.machineGroupEndpoint}`;

    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        console.log("MACHINE GROUPS => ", res);
        setmachineGroup([res?.data].flat());
      })
      .catch((err) => {
        if (err?.response?.status === 500) {
          ShowToastMessage(t("toastr.devices.machineGroup") + t("toastr.general.cantShow.error500"));
        } else if (err?.response?.status === 401) {
          ShowToastMessage(t("toastr.devices.machineGroup") + t("toastr.general.cantShow.error401"));
        } else if (err?.response?.status === 404) {
          ShowToastMessage(t("toastr.devices.machineGroup") + t("toastr.general.cantShow.error404"));
        } else if (err?.response?.status === 204) {
          ShowToastMessage(t("toastr.devices.machineGroup") + t("toastr.general.cantShow.error204"));
        }
        console.log("MACHINE GROUPS ERROR => ", err);
      });
  };

  //OVERVIEW TABLE
  const renderDevicesTable = () => {
    return <DevicesTable dataForTable={devicesTableData} />;
  };

  const returnNamedConnectivityStatuses = (status) => {
    if (status === 0) return "warning"
    else if (status === 1) return "error"
    else if (status === 2) return "ok"
    else if (status === undefined) return "unknown"
  }

  const filterDevicesData = (data, selectedMachineStatuses, selectedMachineNames, selectedMachineCities, selectedMachineCheckboxes) => {
    const filteredData = data.filter((machine) => {
      const acceptedValue = [true];
      const selectedMachineCheckboxesReduced = Object.keys(selectedMachineCheckboxes).reduce(function (r, e) {
        if (acceptedValue.includes(selectedMachineCheckboxes[e])) r[e] = selectedMachineCheckboxes[e];
        return r;
      }, {});
      const machineStatusCheckbox = Object.keys(selectedMachineCheckboxesReduced);
      const machineStatuses = (selectedMachineStatuses || []).map((selected) => selected.value);
      const machineCities = (selectedMachineCities || []).map((selected) => selected.value);
      const machineNamesOnly = (selectedMachineNames || []).map((selected) => selected.value);

      const status = !selectedMachineStatuses.length || machineStatuses.includes(machine.machineStatus);
      const city = !selectedMachineCities.length || machineCities.includes(machine.city);
      const name = !selectedMachineNames.length || machineNamesOnly.includes(machine.machineName);
      const checkbox = !machineStatusCheckbox.length || machineStatusCheckbox.includes(returnNamedConnectivityStatuses(machine.connectivityStatus));

      return status && name && city && checkbox;
    });
    //setFilteredMachineData(filteredData.length ? filteredData : machinesData)
    setFilteredMachineData(filteredData);

    return filteredData;
  };

  const calculateDevicesTableData = (machinesDataResponseData, isSelected) => {
    if (isSelected) {
      const uniqueMachineNames = [...new Set(Object.values(machinesDataResponseData).map((machine) => machine.machineName))];

      setMachineNames(uniqueMachineNames);
    } else {
      setMachineNames([]);
    }
    //COMMENTED SO IT DOESN'T CHANGE ON FILTER UPDATES
    // 1. Total Number of Devices (sum Devices)
    /* const totalDevices = machinesDataResponseData.length;
    setTotalNumberOfDevices(totalDevices);

    //2. Total number of WORKING machines
    setTotalWorking(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Working).length);

    //3. Total number of WARNING machines
    setTotalWarning(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Warning).length);

    //4. Total number of ERROR machines
    setTotalError(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Error).length);

    //5. Total number of UNKNOWN machines
    setTotalUnknown(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Unknown).length); */

    //6. List of all Devices locations
    //setDeviceLocations(machinesDataResponseData.map(machine => ({ serialNumber: machine.serialNumber, latitude: machine.latitude, longitude: machine.longitude })))

    const tableData = machinesDataResponseData.map((machine) => {
      return {
        Status: machine.machineStatus,
        Time: machine.deviceStatusCheckedAt,
        "Connectivity status": machine.connectivityStatus,
        "Operating status": machine.operatingStatus,
        "Operator ID": machine.operatorId,
        "Device ID": machine?.deviceId?.toString(),
        City: machine.city,
        Address: machine.streetNumber ? machine.address + ", " + machine.streetNumber : machine.address,
        "Software version": machine.softwareVersion || EMPTY_DATA_DASH,
      };
    });

    console.log("MACHINES DATA REMAP", { machinesDataResponseData, tableData })

    setDevicesTableData(tableData);
  };

  const calculateDevicesCards = (machinesDataResponseData) => {
    //console.log("RESPONSE MACHINE", res.data, machinesDataResponseData)
    // SET DATA FROM BACKEND
    filterDevicesData(machinesDataResponseData, [], [], [], { ok: true, error: true, warning: true, unknown: true }, undefined);

    setMachineData(machinesDataResponseData);

    // MACHINE STATUSES (filter-out EMPTY values)
    const uniqueMachineStatuses = [
      ...new Set(machinesDataResponseData.filter((machine) => machine?.connectivityStatus !== null).map((machine) => deviceConnectivityStatus(machine.connectivityStatus))),
    ];

    setMachineStatuses(uniqueMachineStatuses);

    // MACHINE CITIES (filter-out EMPTY values)
    const uniqueMachineCities = [...new Set(machinesDataResponseData.filter((machine) => machine?.city !== "").map((machine) => machine.city))];
    setMachineCities(uniqueMachineCities);

    const totalDevices = machinesDataResponseData.length;
    setTotalNumberOfDevices(totalDevices);

    //2. Total number of WORKING machines
    setTotalWorking(machinesDataResponseData.filter((machine) => machine.connectivityStatus === MachineStatus.Working).length);

    //3. Total number of WARNING machines
    setTotalWarning(machinesDataResponseData.filter((machine) => machine.connectivityStatus === MachineStatus.Warning).length);

    //4. Total number of ERROR machines
    setTotalError(machinesDataResponseData.filter((machine) => machine.connectivityStatus === MachineStatus.Error).length);

    //5. Total number of UNKNOWN machines
    setTotalUnknown(machinesDataResponseData.filter((machine) => machine.connectivityStatus === MachineStatus.Unknown).length);
  };

  const postBulkMachineEndpoint = () => {
    let dataForPosting = selectedDevices;

    if (dataForPosting.length !== 0) {
      const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.addDeviceEndpoint}?addToTrackingPool=${addToTrackingPool}`;
      setPostingFlag(true);
      setIsRequestGood(false);
      const config = {
        headers: {
          Authorization: initialized ? `Bearer ${kcToken}` : undefined,
        },
      };
      const formatedData = dataForPosting.map((element) => {
        !element?.longitude ? (element.longitude = 0) : (element.longitude = Number(element.longitude));
        element?.latitude === "" ? (element.latitude = 0) : (element.latitude = Number(element.latitude));
        element?.zipCode === "" ? (element.zipCode = 0) : (element.zipCode = Number(element.zipCode));
        delete element["\r"];
        return element;
      });

      axiosInstance?.current
        ?.post(url, formatedData, config)
        .then((res) => {
          setSelectedDevices([]);
          setOpenModal(true);
          setFinish(false);
          setAddToTrackingPool(false);
        })
        .catch((err) => {
          setFinish(false);
          setAddToTrackingPool(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.devices.bulkUpload") + t("toastr.general.failed.error500") + t("toastr.devices.duplicates"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.devices.bulkUpload") + t("toastr.general.failed.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.devices.bulkUpload") + t("toastr.general.failed.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.devices.bulkUpload") + t("toastr.general.failed.error204"));
          }
          console.log(err);
        });
    }
  };

  const postNewDeviceMachineEndpoint = (data) => {
    if (data.length !== 0) {
      const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.addDeviceEndpoint}?addToTrackingPool=${addToTrackingPool}`;
      const config = {
        headers: {
          Authorization: initialized ? `Bearer ${kcToken}` : undefined,
        },
      };

      const dataObject = {
        ...data,
        longitude: data.longitude === "" ? (data.longitude = 0) : Number(data.longitude),
        latitude: data.latitude === "" ? (data.latitude = 0) : Number(data.latitude),
        zipCode: data.zipCode === "" ? (data.zipCode = 0) : Number(data.zipCode),
      };
      const formatedData = dataObject;

      console.log(formatedData)

      axiosInstance?.current
        ?.post(url, [formatedData], config)
        .then((res) => {
          setOpenModal(true);
          setFinish(false);
          data = [];
          setAddToTrackingPool(false);
          console.log(res);
        })
        .catch((err) => {
          setFinish(false);
          setAddToTrackingPool(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.devices.machineAdding") + t("toastr.general.failed.error500"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.devices.machineAdding") + t("toastr.general.failed.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.devices.machineAdding") + t("toastr.general.failed.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.devices.machineAdding") + t("toastr.general.failed.error204"));
          }
          console.log(err);
        });
    }
  };

  const deleteDevice = (machineId) => {
    setLoadingFlag(true);

    const newBackendUrl = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.deleteDevice}/${machineId}`;

    axiosInstance?.current
      ?.delete(newBackendUrl)
      .then((res) => {
        getMachineStatesBufferedEndpoint();
        navigate(`${process.env.PUBLIC_URL}${DASHBOARD_ROUTES.ROOT}${DASHBOARD_ROUTES.DEVICE_PAGE}/`);
        setLoadingFlag(false);
      })
      .catch((err) => {
        if (err?.response?.status === 500) {
          ShowToastMessage(t("toastr.devices.machineDeletion") + t("toastr.general.failed.error500"));
        } else if (err?.response?.status === 401) {
          ShowToastMessage(t("toastr.devices.machineDeletion") + t("toastr.general.failed.error401"));
        } else if (err?.response?.status === 404) {
          ShowToastMessage(t("toastr.devices.machineDeletion") + t("toastr.general.failed.error404"));
        } else if (err?.response?.status === 204) {
          ShowToastMessage(t("toastr.devices.machineDeletion") + t("toastr.general.failed.error204"));
        }
        setLoadingFlag(false);
      });
  };

  const getMachineStatesBufferedEndpoint = (startDate, endDate) => {
    //console.log("GET getMachineStatesBufferedEndpoint ====> ", { startDate, endDate })

    //Set last Start/End date
    /* setStartDate(startDate);
    setEndDate(endDate); */

    setLoadingFlag(true);

    const newBackendUrl = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.getAllMachines}`;

    axiosInstance?.current
      ?.get(newBackendUrl)
      .then((res) => {
        setLoadingFlag(false);

        const machinesDataResponseDataNewBack = res?.data || [];

        const currentUserEmail = keycloak?.tokenParsed?.email;

        const addStatusToDevices = machinesDataResponseDataNewBack.map((device) => {
          if (device?.machineStatus === undefined) {
            device.machineStatus = MachineStatus.Unknown;
          }
          return device;
        });

        calculateDevicesTableData(addStatusToDevices, false);
        calculateDevicesCards(addStatusToDevices);
      })
      .catch((err) => {
        setLoadingFlag(false);
        if (err?.response?.status === 500) {
          ShowToastMessage(t("toastr.devices.machineFetch") + t("toastr.general.failed.error500"));
        } else if (err?.response?.status === 401) {
          ShowToastMessage(t("toastr.devices.machineFetch") + t("toastr.general.failed.error401"));
        } else if (err?.response?.status === 404) {
          ShowToastMessage(t("toastr.devices.machineFetch") + t("toastr.general.failed.error404"));
        } else if (err?.response?.status === 204) {
          ShowToastMessage(t("toastr.devices.machineFetch") + t("toastr.general.failed.error204"));
        }
        console.log("DEVICES ERROR", err);
      });
  };

  const callPeriodDataFetch = (startDate, endDate) => {
    getMachineStatesBufferedEndpoint(startDate, endDate);
  };

  useEffect(() => {
    if (initialized) {
      if (merchantId !== undefined) {
        getMachineStatesBufferedEndpoint(startDate, endDate);
        //setDevicesTableData([])
        getmachineGroup();
      }
    }
  }, [initialized, merchantId]);

  const ShowToastMessage = (text) =>
    toast(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{text}</p>, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    });

  return {
    startDate,
    endDate,
    machinesData,
    machinesDataCardsData: [
      //{ title: "Total Devices", subtitle: "Total Number of Devices", value: totalNumberOfDevices, type: "number" },
      {
        title: `${t("devices.cards.total")}`,
        subtitle: `${t("devices.cards.totalMachines")}`,
        value: totalNumberOfDevices,
        type: "number",
      },
      {
        title: `${t("devices.cards.working_up")}`,
        subtitle: `${t("devices.cards.workingMachines")}`,
        value: totalWorking,
        type: "number",
      },
      {
        title: `${t("devices.cards.warning_up")}`,
        subtitle: `${t("devices.cards.warningMachines")}`,
        value: totalWarning,
        type: "number",
      },
      {
        title: `${t("devices.cards.error_up")}`,
        subtitle: `${t("devices.cards.errorMachines")}`,
        value: totalError,
        type: "number",
      },
      {
        title: `${t("devices.cards.unknown_up")}`,
        subtitle: `${t("devices.cards.unknownMachines")}`,
        value: totalUnknown,
        type: "number",
      },
    ],
    setFinish,
    finish,
    finishEdit,
    setFinishEdit,
    machineStatuses,
    machineCities,
    machineNames,
    machineGroup,
    //deviceLocations,
    callFilter: (startDate, endDate) => callPeriodDataFetch(startDate, endDate),
    calculateDevicesTableData,
    filterDevicesData,
    devicesTableData,
    SearchableDevicesTable: renderDevicesTable(),
    //DevicesManagmentBackendTable: renderDevicesTableNewBackEnd(),
    ImportedBulkTable: renderBulkTable(),
    filteredMachineData,
    getMachineStatesBufferedEndpoint,
    deleteDevice,
    setSelectedDevices,
    setSelectedDevicesLength,
    setAllDevices,
    postNewDeviceMachineEndpoint,
    postBulkMachineEndpoint,
    getmachineGroup,
    setMachineAddStatus,
    setIsRequestGood,
    setOpenModal,
    setOpenModalForDelete,
    machineAddStatus,
    postingFlag,
    isRequestGood,
    openModal,
    openModalForDelete,
    allRows,
    selectedRows,
    loadingFlag,
    areMachinesVisible,
    setAreMachinesVisible,
    addNewDeviceData,
    setEditableMachine,
    setMachineId,
    machineId,
    editableMachine,
    addToTrackingPool,
    setAddToTrackingPool,
  };
};
